// src/api/axiosInstance.js
import axios from "axios";
import { getToken, removeToken } from "../utils/tokenService";

const axiosInstance = axios.create({
  baseURL: "https://ratcrm.zentelex.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token automatically to protected API requests.
// Login and MFA-login requests must NOT receive an old JWT.
axiosInstance.interceptors.request.use((config) => {
  const requestUrl = String(config.url || "");

  const isLoginRequest =
    requestUrl === "/auth/login" ||
    requestUrl.endsWith("/auth/login");

  const isMfaLoginRequest =
    requestUrl === "/auth/mfa/verify" ||
    requestUrl.endsWith("/auth/mfa/verify");

  if (!isLoginRequest && !isMfaLoginRequest) {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
});

// Automatically handle expired JWT.
axiosInstance.interceptors.response.use(
  (response) => response,

  (error) => {
    const status = error?.response?.status;
    const message = String(
      error?.response?.data?.message || ""
    ).toLowerCase();

    if (status === 401 && message.includes("jwt expired")) {
      removeToken();
      sessionStorage.clear();

      if (window.location.pathname !== "/signin") {
        window.location.href = "/signin";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
